import {GetServicePointsParams} from 'domain/usecases/private/service-points/get-service-points';
import {makeGetServicePoints} from 'main/factories/usecases/private/service-points/get-service-points-factory';

export async function getServicePoints(params: GetServicePointsParams) {
	const response = await makeGetServicePoints().get(params);

	if (!response) {
		return {
			canaisAtendimento: [],
			paginacao: {
				paginaAtual: 0,
				tamanhoPagina: params.size ?? 10,
				totalRegistros: 0,
				totalPaginas: 1,
				primeiraPagina: true,
				ultimaPagina: true,
			},
		};
	}

	return response;
}
